import { BaseRequest } from '@/network/requests/BaseRequest';
import { color_xxx } from '@/interfaces/color_xxx';

/**
 * 根据批次id获取颜色信息请求对象（一个colorInfo 对应多个 color）
 * @param defectBatchId 批次id
 */
export const getColorRequest = (defectBatchId: string) => BaseRequest.build<color_xxx>(`color_${defectBatchId}`);
